import React from 'react';
import '../css/App.css';
import '../css/Comments.css';
import ReactStars from "react-rating-stars-component";
import {withRouter} from "react-router";
class Comments extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            comments: props.comments,
        };
    }
    componentWillReceiveProps(props) {
        this.setState(
            {
                comments:props.comments,
            });
    }

    render() {
        return (
            <div id={"comments"} >
                {this.state.comments.map((comment)=>{
                    return(
                        <div className={"comment_item"}>
                            <div className={"comment_owner"}>{comment.comment_name}</div>
                            <div className={"comment_rate"}>
                                <ReactStars
                                    count={5}
                                    value={comment.comment_rate}
                                    size={15}
                                    isHalf={true}
                                    emptyIcon={<i className="far fa-star"></i>}
                                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                                    fullIcon={<i className="fa fa-star"></i>}
                                    activeColor="#ffd700"
                                    edit={false}/>
                            </div>
                            <div className={"comment_date"}>{comment.comment_date}</div>
                            <div className={"comment_text"}>{comment.comment_text}</div>
                        </div>
                    )
                })}
            </div>
        )
    }

}

export default withRouter(Comments);
